<template>
	<div
		v-if="account"
		id="select-account"
		class="modal fade"
		tabindex="-1"
		data-backdrop="static"
		data-keyboard="false"
		aria-labelledby="select-account"
		aria-hidden="true"
	>
		<div class="modal-dialog stop">
			<div class="modal-content overflow-hidden stop">
				<div class="modal-body p-4 p-md-5">
					<div class="flex flex-col items-center mb-4">
						<button
							type="button"
							class="btn mb-4 py-5"
						>
							<i class="far fa-user mx-4"></i>
						</button>
						<h2 class="mb-0 font-24 text-center">
							SELECIONE UMA ORGANIZAÇÃO
						</h2>
					</div>
					<form class="row justify-content-between">
						<div
							id="organizations-list"
							class="col-12"
						>
							<div
								v-for="(
									requester, index
								) in filtered_requesters"
								:key="index"
							>
								<hr
									v-if="
										requester.account_requester_id ===
										getEngineOrganization
									"
									class="my-3"
								/>
								<div
									class="select-card with-border mt-2"
									:class="{
										active:
											requester.account_requester_id ===
											requester_selected_id,
										engine:
											requester.account_requester_id ===
											getEngineOrganization,
									}"
								>
									<label
										for="card-checkbox"
										class="pr-55 text-uppercase text-overflow"
										@click="SelectAccount(requester)"
									>
										{{ requester.requester.name }}
										<i
											v-if="
												typeof requester.confirmed !==
													'undefined' &&
												!requester.confirmed
											"
											class="far fa-envelope font-24 text-danger"
										></i>
										<i
											v-else
											class="far fa-chevron-right"
										></i>
									</label>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'

	export default {
		name: 'SelectAccount',
		props: {
			open: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {}
		},
		computed: {
			...mapGetters('auth', [
				'account',
				'requesters',
				'requester_selected_id',
				'is_registered',
				'subscription_info',
			]),
			getEngineOrganization() {
				return parseInt(process.env.VUE_APP_ENGINE_ORGANIZATION_ID)
			},
			filtered_requesters() {
				const engine_organization = this.getEngineOrganization

				const engine = this.requesters.find(
					r => r.account_requester_id === engine_organization
				)
				const user_organizations = this.requesters.filter(
					r => r.instance && r.instance.status
				)

				return engine
					? [...user_organizations, engine]
					: user_organizations
			},
		},
		watch: {
			open: {
				handler(val) {
					window
						.jQuery('#select-account')
						.modal(val ? 'show' : 'hide')
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('auth', [
				'SetRequesterAccount',
				'GetAuthAccount',
				'GetSubscriptionInfo',
				'IsRegistered',
			]),

			async SelectAccount(requester) {
				this.SetRequesterAccount(requester)

				this.$emit('change-account')

				this.Close()
			},
			Close() {
				window.jQuery('#select-account').modal('hide')

				this.$emit('close')
			},
		},
		async mounted() {
			if (!this.requester_selected_id) {
				window.jQuery('#select-account').modal('show')
			} else {
				window.Echo.RunOrganizationPool()
			}

			document.addEventListener('keyup', e => {
				if (e.keyCode === 27 && this.requester_selected_id) {
					this.Close()
				}
			})
		},
	}
</script>

<style lang="scss" scoped>
	.modal-body {
		background-color: var(--elementsBackgroundColor);

		#organizations-list {
			background-color: var(--gridBackgroundColor);
			border-radius: 0.5rem;
			max-height: 55vh;
			overflow: auto;

			&::-webkit-scrollbar-thumb {
				background-color: var(--newPrimaryBackgroundColor);
			}
		}

		hr {
			border-color: var(--elementsBorderColor);
		}
	}

	.btn {
		padding: 0.7rem 1rem;
		background-color: var(--newPrimaryBackgroundColor);
		border: 1px solid var(--newPrimaryBackgroundColor);
		color: var(--newPrimaryColor);
		outline: none;
		border-radius: 0.375rem;
		transition: all 0.1s ease-in-out;
		display: flex;
		align-items: center;
		justify-content: center;

		height: 2.625rem;
		font-size: 0.813rem;
		font-weight: 900;
		line-height: 1.219rem;
		font-size-adjust: none;
		font-stretch: 100%;
		letter-spacing: 0.1em;

		&:hover {
			background-color: var(--newPrimaryHoverBackgroundColor);
			border-color: var(--newPrimaryHoverBackgroundColor);
			color: var(--newPrimaryHoverColor);
		}

		&:active {
			background-color: var(--newPrimaryActiveBackgroundColor);
			border-color: var(--newPrimaryActiveBackgroundColor);
			color: var(--newPrimaryActiveColor);
		}
	}
</style>
